import * as Types from "../actionTypes/mailTypes";

const initialState = { listData: [] };

export const mailListReducer = (state = initialState, action) => {
  switch (action.type) {
    case Types.SET_MAIL_LIST:
      return action.payload;
    case Types.SET_MAIL_LIST_DEFAULT:
      return state;
    default:
      return state;
  }
};

export const mailToListReducer = (state = initialState, action) => {
  switch (action.type) {
    case Types.SET_MAIL_TO_LIST:
      return action.payload;
    case Types.SET_MAIL_LIST_DEFAULT:
      return state;
    default:
      return state;
  }
};

export const mailTempListReducer = (state = initialState, action) => {
  switch (action.type) {
    case Types.SET_MAIL_TEMP_LIST:
      return action.payload;
    case Types.SET_MAIL_LIST_DEFAULT:
      return state;
    default:
      return state;
  }
};

const addressListInitialState = { teamListData: [] };

export const addressListReducer = (state = addressListInitialState, action) => {
  switch (action.type) {
    case Types.SET_ADDRESS_LIST:
      return action.payload;
    default:
      return state;
  }
};
